<template>
  <v-card class="rsl-fixed-height">
    <v-tabs v-model="tab">
      <v-tab @click="refreshProcesses">
        {{ $t('PROCESSES.TABS.DESIGN') }}
      </v-tab>
      <v-tab @click="refreshProcesses">
        {{ $t('PROCESSES.TABS.DEPLOYED') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('PROCESSES.SEARCH_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="mr-2"
                    color="warning"
                    @click="migrateCases()"
                  >{{ $t('PROCESSES.BTNS.MIGRATE') }}</v-btn>
                  <v-btn
                    small
                    class="mr-2"
                    color="warning"
                    @click="importProcess()"
                  >{{ $t('PROCESSES.BTNS.IMPORT') }}</v-btn>
                  <v-btn
                    small
                    class="mr-2"
                    color="success"
                    @click="buildProcess()"
                  >{{ $t('PROCESSES.BTNS.NEW') }}</v-btn>
                </v-card-title>
                <v-data-table
                  :headers="processHeaders"
                  :items="allProcessXml"
                  :items-per-page="25"
                  :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
                  :search="search"
                  class="elevation-1 process-design"
                  item-key="ID"
                  :sort-by="designSortBy"
                  :sort-desc="designSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loading"
                >
                  <template slot="item.actions" slot-scope="row">
                    <v-btn
                      v-if="row.item.IS_LOCKED == 1"
                      small
                      class="mr-2"
                      color="warning"
                      @click="showLocked(row.item)"
                    >
                      <v-icon small>mdi-lock</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="row.item.IS_LOCKED == 0"
                      small
                      class="mr-2"
                      color="warning"
                      @click="editProcess(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.EDIT') }}
                    </v-btn>
                    <v-btn
                      small
                      class="mr-2"
                      color="error"
                      :disabled="row.item.VERSION > 1 || row.item.IS_LOCKED == 1 || !allowDeletion"
                      @click="deleteProcessXml(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.DELETE') }}
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('PROCESSES.SEARCH_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="mr-2"
                    color="warning"
                    @click="setVariables()"
                  >{{ $t('PROCESSES.BTNS.SET_VARS') }}</v-btn>
                  <v-btn
                    small
                    class="mr-2"
                    color="success"
                    @click="setStartVariables()"
                  >{{ $t('PROCESSES.BTNS.SET_START_VARS') }}</v-btn>
                </v-card-title>
                <v-data-table
                  :headers="deployedHeaders"
                  :items="allProcesses"
                  :items-per-page="25"
                  :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
                  :search="search"
                  class="elevation-1 process-deployed"
                  item-key="deploymentId"
                  :sort-by="deployedSortBy"
                  :sort-desc="deployedSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loading"
                >
                  <template slot="item.actions" slot-scope="row">
                    <v-btn
                      small
                      class="mr-2"
                      color="secondary"
                      @click="viewProcessMap(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.VIEW') }}
                    </v-btn>
                    <v-btn
                      small
                      class="mr-2"
                      color="error"
                      @click="deleteProcess(row.item)"
                      :disabled="!allowUndeploy"
                    >
                      {{ $t('PROCESSES.BTNS.UNDEPLOY') }}
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="deleteDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ deleteTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ deleteTextProcess }}</div>
            <div class="pt-5">{{ deleteTextVersion }}</div>
            <div class="pt-5 warning-text">{{ deleteTextWarning }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="deleteDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmDelete()"
              :loading="loadingUndeploy"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="deleteXmlDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ deleteTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ deleteTextProcess }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="deleteXmlDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmDeleteXml()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="importProcessDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ importTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ importText }}</div>
            <v-file-input
              v-model="importedFile"
              :label="$t('PROCESSES.IMPORT_PROCESS.FIELDS.LABEL')"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelImportProcess()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmImportProcess()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="showLockedDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ lockedTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ lockedText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              color="warning"
              @click="forceUnlock()"
            >{{ $t('PROCESSES.BTNS.FORCE_UNLOCK') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="showLockedDialog = false"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="1000"
        v-model="processMapDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ processMapTitle }}
            <v-spacer></v-spacer>
            <v-btn
              small
              class="mr-2"
              color="secondary"
              @click="closeProcessMap()"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-toolbar>
          <v-card-text>
            <div id="canvas" class="canvas"></div>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="800"
        v-model="migrateDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ migrateTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ migrateText }}</div>
            <div class="pt-5 red--text">{{ migrateWarning }}</div>
            <v-select
              v-model="sourceProcess"
              :label="$t('PROCESSES.MIGRATE_CASES.FIELDS.SOURCE')"
              :items="sourceProcesses"
              item-text="label"
              item-value="value"
              @change="filterTargets"
            ></v-select>
            <v-select
              v-model="targetProcess"
              :label="$t('PROCESSES.MIGRATE_CASES.FIELDS.TARGET')"
              :items="targetProcesses"
              item-text="label"
              item-value="value"
            ></v-select>
            <v-data-table
              v-model="targetInstances"
              :headers="instanceHeaders"
              :items="activeInstances"
              :items-per-page="10"
              class="mx-3 mb-3"
              item-key="id"
              sort-by="caseId"
              show-select
              loading-text="Loading... Please wait"
              :loading="loadingInstances"
            ></v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="closeMigrateCases()"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="error"
              @click="confirmMigrateCases()"
              :disabled="!sourceProcess.id || !targetProcess.id || targetInstances.length == 0"
            >{{ $t('PROCESSES.BTNS.MIGRATE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="800"
        v-model="setVarsDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ setVarsTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ setVarsText }}</div>
            <v-row>
              <v-col md="8">
                <v-select
                  v-model="sourceProcess"
                  :label="$t('PROCESSES.SET_VARS.FIELDS.SOURCE')"
                  :items="sourceProcesses"
                  item-text="label"
                  item-value="value"
                  @change="filterTargets"
                ></v-select>
              </v-col>
              <v-col md="4">
                <v-select
                  v-model="targetVarType"
                  :label="$t('PROCESSES.SET_VARS.FIELDS.TYPE')"
                  :items="targetVarTypes"
                  item-text="label"
                  item-value="value"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="mb-4">
              <v-col md="6">
                <v-text-field
                  v-model="targetVarName"
                  :label="$t('PROCESSES.SET_VARS.FIELDS.NAME')"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  v-model="targetVarValue"
                  :label="$t('PROCESSES.SET_VARS.FIELDS.VALUE')"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
              v-model="targetInstances"
              :headers="instanceHeaders"
              :items="activeInstances"
              :items-per-page="10"
              class="mx-3 mb-3"
              item-key="id"
              sort-by="caseId"
              show-select
              loading-text="Loading... Please wait"
              :loading="loadingInstances"
            ></v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="closeSetVariables()"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="error"
              @click="confirmSetVariables()"
              :disabled="!sourceProcess.id || !targetVarType || !targetVarName || !targetVarValue || targetInstances.length == 0"
            >{{ $t('PROCESSES.BTNS.SET_VARS') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="800"
        v-model="setStartVarsDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ setStartVarsTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ setStartVarsText }}</div>
            <v-select
              v-model="sourceProcess"
              :label="$t('PROCESSES.SET_VARS.FIELDS.SOURCE')"
              :items="sourceProcesses"
              item-text="label"
              item-value="value"
              @change="filterTargets"
            ></v-select>
            <v-data-table
              :headers="startVarsHeaders"
              :items="startVarsItems"
              :items-per-page="10"
              class="mx-3 mb-3"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-btn
                    color="error"
                    @click="resetStartVars()"
                  >
                    {{ $t('PROCESSES.SET_VARS.RESET_BTN') }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-dialog
                    v-model="editStartVarDialog"
                    max-width="600px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ $t('PROCESSES.SET_VARS.FIELDS.NEW_VAR') }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ addStartVarTitle }}</v-toolbar>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedStartVarItem.varName"
                                :label="$t('PROCESSES.SET_VARS.FIELDS.NAME')"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedStartVarItem.varValue"
                                :label="$t('PROCESSES.SET_VARS.FIELDS.VALUE')"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            >
                              <v-select
                                v-model="editedStartVarItem.varType"
                                :label="$t('PROCESSES.SET_VARS.FIELDS.TYPE')"
                                :items="targetVarTypes"
                                item-text="label"
                                item-value="value"
                                class="pt-0"
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn
                          text
                          @click="closeEditStartVar()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="saveEditStartVar()"
                        >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="deleteStartVarDialog" max-width="500px">
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ $t('PROCESSES.SET_VARS.DEL_TEXT') }}</v-toolbar>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="closeDeleteStartVar()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="error"
                          @click="confirmDeleteStartVar()"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template slot="item.actions" slot-scope="row">
                <v-btn
                  small
                  class="mr-2 float-right"
                  color="error"
                  @click="deleteStartVarItem(row.item)"
                ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                <v-btn
                  small
                  class="mr-2 float-right"
                  color="warning"
                  @click="editStartVarItem(row.item)"
                ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="closeSetStartVariables()"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="confirmSetStartVariables()"
              :disabled="!sourceProcess.id"
            >{{ $t('PROCESSES.BTNS.SET_START_VARS') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import $ from 'jquery';
  import NavViewer from '../assets/process-builder/lib/NavViewer';
  import { mapGetters } from 'vuex';
  export default {
    name: 'processdesigner',
    computed: {
      ...mapGetters(['allProcesses', 'allProcessXml', 'latestVersions', 'processLocked', 'processLockedUser', 'enableProcessUndeploy', 'enableProcessDeletion', 'processMap', 'migrationSuccess', 'allTasks', 'setVarSuccess', 'starterVarsSaved', 'starterVars'])
    },
    data: function() {
      return {
        loading: false,
        loadingUndeploy: false,
        tab: null,
        allowUndeploy: false,
        allowDeletion: false,
        importProcessDialog: false,
        importTitle: '',
        importText: '',
        importedFile: null,
        showLockedDialog: false,
        lockedProcessKey: '',
        lockedTitle: '',
        lockedText: '',
        deleteDialog: false,
        deleteXmlDialog: false,
        deleteTitle: '',
        deleteTextProcess: '',
        deleteTextVersion: '',
        deleteTextWarning: '',
        deleteKey: null,
        theProcessName: '',
        theProcessDefinitionId: '',
        processMapDialog: false,
        processMapTitle: '',
        deploymentId: '',
        xmlId: '',
        search: '',
        designSortBy: '',
        designSortDesc: false,
        deployedSortBy: '',
        deployedSortDesc: false,
        deployedHeaders: [
          {
            text: this.$t('PROCESSES.FIELDS.PROCESS_ID'),
            align: 'start',
            sortable: true,
            value: 'deploymentId',
            groupable: false
          },
          { text: this.$t('PROCESSES.FIELDS.PROCESS_NAME'), value: 'name' },
          { text: this.$t('PROCESSES.FIELDS.PROCESS_KEY'), value: 'key' },
          { text: this.$t('PROCESSES.FIELDS.PROCESS_VERSION'), value: 'version' },
          { text: this.$t('PROCESSES.FIELDS.TENANT_ID'), value: 'tenantId' },
          { text: this.$t('PROCESSES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        processHeaders: [
          {
            text: this.$t('PROCESSES.FIELDS.PROCESS_NAME'),
            align: 'start',
            sortable: true,
            value: 'PROCESS_NAME'
          },
          { text: this.$t('PROCESSES.FIELDS.DEPLOY_NAME'), value: 'NAME' },
          { text: this.$t('PROCESSES.FIELDS.PROCESS_VERSION'), value: 'VERSION' },
          { text: this.$t('PROCESSES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        snack: false,
        snackColor: '',
        snackText: '',
        migrateDialog: false,
        migrateTitle: '',
        migrateText: '',
        migrateWarning: '',
        sourceProcess: {},
        targetProcess: {},
        sourceProcesses: [],
        targetProcesses: [],
        loadingInstances: false,
        instanceHeaders: [
          {
            text: this.$t('PROCESSES.MIGRATE_CASES.FIELDS.CASE_ID'),
            align: 'start',
            sortable: true,
            value: 'caseId'
          },
          { text: this.$t('PROCESSES.MIGRATE_CASES.FIELDS.CASE_LABEL'), value: 'caseLabel' },
          { text: this.$t('PROCESSES.MIGRATE_CASES.FIELDS.TASK_NAME'), value: 'name' },
          { text: this.$t('PROCESSES.MIGRATE_CASES.FIELDS.ASSIGNEE'), value: 'assignee' }
        ],
        activeInstances: [],
        targetInstances: [],
        setVarsDialog: false,
        setVarsTitle: '',
        setVarsText: '',
        targetVarType: '',
        targetVarTypes: [
          { label: 'String', value: 'String' },
          { label: 'Integer', value: 'Integer' },
          { label: 'Boolean', value: 'Boolean' },
          // { label: 'JSON', value: 'Json' }
        ],
        targetVarName: '',
        targetVarValue: '',
        setStartVarsDialog: false,
        setStartVarsTitle: this.$t('PROCESSES.SET_VARS.START_VARS_TITLE'),
        setStartVarsText: this.$t('PROCESSES.SET_VARS.START_VARS_TEXT'),
        addStartVarTitle: this.$t('PROCESSES.SET_VARS.ADD_VAR_TITLE'),
        startVarsHeaders: [
          { text: this.$t('PROCESSES.SET_VARS.FIELDS.NAME'), align: 'start', sortable: false, value: 'varName' },
          { text: this.$t('PROCESSES.SET_VARS.FIELDS.TYPE'), value: 'varType' },
          { text: this.$t('PROCESSES.SET_VARS.FIELDS.VALUE'), value: 'varValue' },
          { text: this.$t('PROCESSES.SET_VARS.FIELDS.ACTIONS'), sortable: false, value: 'actions' }
        ],
        startVarsItems: [],
        editedStartVarItem: {
          varName: '',
          varType: '',
          varValue: ''
        },
        defaultStartVarItem: {
          varName: '',
          varType: '',
          varValue: ''
        },
        editedStartVarIndex: -1,
        deleteStartVarDialog: false,
        editStartVarDialog: false
      }
    },
    created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'ENABLE_PROCESS_UNDEPLOY') {
          this.allowUndeploy = JSON.parse(this.enableProcessUndeploy);
        }

        if(mutation.type === 'ENABLE_PROCESS_DELETION') {
          this.allowDeletion = JSON.parse(this.enableProcessDeletion);
        }

        if(mutation.type === 'PROCESS_MAP') {
          this.processMapTitle = this.$t('PROCESSES.MAP_TEXT') + ' ' + this.theProcessName;
          this.processMapDialog = true;
          let canvas = document.getElementById('canvas');
          this.viewer = new NavViewer({ 
            container: canvas
          });

          this.viewer.importXML(this.processMap).then( () => {
            this.viewer.attachTo('#canvas');
            this.viewer.get('canvas').zoom('fit-viewport');
          });
        }

        if(mutation.type === 'ALL_TASKS') {
          if(this.allTasks.length > 0) {
            for(let i = 0; i < this.allTasks.length; i++) {
              if(this.allTasks[i].processDefinitionId == this.sourceProcess.id) {
                this.activeInstances.push(this.allTasks[i]);
              }
            }
            this.loadingInstances = false;
          }
          
        }

        if(mutation.type === 'MIGRATION_SUCCESS') {
          this.snackMigration(this.migrationSuccess);
        }

        if(mutation.type === 'SET_VAR_SUCCESS') {
          this.snackSetVar(this.setVarSuccess);
        }

        if(mutation.type === 'STARTER_VARS') {
          if(this.starterVars.value) {
            this.startVarsItems = JSON.parse(this.starterVars.value);
          }else {
            this.startVarsItems = [];
          }
        }

        if(mutation.type === 'STARTER_VARS_SAVED') {
          this.snackVarsSaved(this.starterVarsSaved);
        }

      });

      let payload = { 'action': 'getAll' };
      this.$store.dispatch('processSettings', payload);

      this.refreshProcesses();
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      async refreshProcesses() {
        this.loading = true;
        await this.$store.dispatch('getAllProcesses').then( () => {
          if(this.deleteKey !== null) {
            let version = 0;
            if(this.latestVersions[this.deleteKey]) {
              version = parseInt(this.latestVersions[this.deleteKey]);
            }

            let payload = {
              'processKey': this.deleteKey,
              'version': version
            };
            
            this.$store.dispatch('updateXmlVersion', payload).then( () => {
              let payload = {
                'processKey': this.deleteKey,
                'processVersion': version
              };

              this.$store.dispatch('markFormsUndeployed', payload).then( () => {
                this.$store.dispatch('getAllProcessXml');
              });
            });
          }else {
            this.$store.dispatch('getAllProcessXml');
          }
          this.loading = false;
          // Apply sort field and order
          let designField = this.$store.state.designSortField;
          let designSort = this.$store.state.designSortOrder;
          let deployedField = this.$store.state.deployedSortField;
          let deployedSort = this.$store.state.deployedSortOrder;
          if(designField == null) {
            this.designSortBy = 'PROCESS_NAME';
            this.designSortDesc = false;
          }else if (designSort == 'none') {
            this.designSortBy = '';
            this.designSortDesc = false;
          }else {
            this.designSortBy = designField;

            if(designSort == 'descending') {
              this.designSortDesc = true;
            }else {
              this.designSortDesc = false;
            }
          }
          if(deployedField == null) {
            this.deployedSortBy = 'version';
            this.deployedSortDesc = true;
          }else if (deployedSort == 'none') {
            this.deployedSortBy = '';
            this.deployedSortDesc = false;
          }else {
            this.deployedSortBy = deployedField;

            if(deployedSort == 'descending') {
              this.deployedSortDesc = true;
            }else {
              this.deployedSortDesc = false;
            }
          }
          // Remove previous click events
          $('.text-start.sortable').off();
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let closest = $(this).closest('.v-data-table');
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            if(closest.hasClass('process-design')) {
              for(let i = 0; i < ref.processHeaders.length; i++) {
                if(column == ref.processHeaders[i].text) {
                  ref.$store.commit('setDesignSortField', ref.processHeaders[i].value);
                  ref.$store.commit('setDesignSortOrder', order);
                }
              }
            }
            // Use same click event for deployed processes
            if(closest.hasClass('process-deployed')) {
              for(let i = 0; i < ref.deployedHeaders.length; i++) {
                if(column == ref.deployedHeaders[i].text) {
                  ref.$store.commit('setDeployedSortField', ref.deployedHeaders[i].value);
                  ref.$store.commit('setDeployedSortOrder', order);
                }
              }
            }
          });
        });
      },
      readFile(file, callback) {
        var reader = new FileReader();
        reader.onloadend = callback;
        reader.readAsText(file);
      },
      filterTargets() {
        this.targetProcesses = [];

        for(let i = 0; i < this.allProcesses.length; i++) {
          if(this.allProcesses[i].key == this.sourceProcess.key) {
            if(this.allProcesses[i].version > this.sourceProcess.version) {
              let sourceObj = {
                'label': this.allProcesses[i].name + ' - (Version: ' + this.allProcesses[i].version + ')',
                'value': this.allProcesses[i]
              }
              this.targetProcesses.push(sourceObj);
            }
          }
        }

        this.targetInstances = [];
        this.activeInstances = [];

        this.loadingInstances = true;
        this.$store.dispatch('getAllTasks');
        this.$store.dispatch('getStarterVars', this.sourceProcess.key);
      },
      migrateCases() {
        this.sourceProcesses = [];
        this.targetProcesses = [];

        for(let i = 0; i < this.allProcesses.length; i++) {
          let sourceObj = {
            'label': this.allProcesses[i].name + ' - (Version: ' + this.allProcesses[i].version + ')',
            'value': this.allProcesses[i]
          }
          this.sourceProcesses.push(sourceObj);
        }

        this.migrateTitle = this.$t('PROCESSES.MIGRATE_CASES.TITLE');
        this.migrateText = this.$t('PROCESSES.MIGRATE_CASES.TEXT');
        this.migrateWarning = this.$t('PROCESSES.MIGRATE_CASES.WARNING');
        this.migrateDialog = true;
      },
      confirmMigrateCases() {
        this.migrateDialog = false;

        let targetArray = [];

        if(this.targetInstances.length > 0) {

          for(let i = 0; i < this.targetInstances.length; i++) {
            targetArray.push(this.targetInstances[i].processInstanceId);
          }

          let payload = {
            'sourceProcessDefId': this.sourceProcess.id,
            'targetProcessDefId': this.targetProcess.id,
            'targetInstances': targetArray
          }
          
          this.$store.dispatch('migrateCases', payload);
        }else {
          this.snackMigration(false);
        }

        this.sourceProcesses = [];
        this.targetProcesses = [];
        this.sourceProcess = {};
        this.targetProcess = {};
        this.activeInstances = [];
        this.targetInstances = [];
      },
      closeMigrateCases() {
        this.migrateDialog = false;
        this.sourceProcesses = [];
        this.targetProcesses = [];
        this.sourceProcess = {};
        this.targetProcess = {};
        this.activeInstances = [];
        this.targetInstances = [];
      },
      setVariables() {
        this.sourceProcesses = [];

        for(let i = 0; i < this.allProcesses.length; i++) {
          let sourceObj = {
            'label': this.allProcesses[i].name + ' - (Version: ' + this.allProcesses[i].version + ')',
            'value': this.allProcesses[i]
          }
          this.sourceProcesses.push(sourceObj);
        }

        this.setVarsTitle = this.$t('PROCESSES.SET_VARS.TITLE');
        this.setVarsText = this.$t('PROCESSES.SET_VARS.TEXT');
        this.setVarsDialog = true;
      },
      confirmSetVariables() {
        this.setVarsDialog = false;

        let targetArray = [];

        if(this.targetInstances.length > 0) {
          for(let i = 0; i < this.targetInstances.length; i++) {
            targetArray.push(this.targetInstances[i].processInstanceId);
          }

          let payload = {
            'varName': this.targetVarName,
            'varType': this.targetVarType,
            'varValue': this.targetVarValue,
            'targetInstances': targetArray
          }
          
          this.$store.dispatch('setVariables', payload);
        }

        this.sourceProcesses = [];
        this.targetProcesses = [];
        this.targetVarType = '';
        this.targetVarName = '';
        this.targetVarValue = '';
        this.activeInstances = [];
        this.targetInstances = [];
        this.sourceProcess = {};
      },
      closeSetVariables() {
        this.setVarsDialog = false;
        this.sourceProcesses = [];
        this.targetProcesses = [];
        this.targetVarType = '';
        this.targetVarName = '';
        this.targetVarValue = '';
        this.activeInstances = [];
        this.targetInstances = [];
        this.sourceProcess = {};
      },
      editStartVarItem(item) {
        this.editedStartVarIndex = this.startVarsItems.indexOf(item)
        this.editedStartVarItem = Object.assign({}, item)
        this.editStartVarDialog = true;
      },
      saveEditStartVar() {
        // Update startVarsItems
        if (this.editedStartVarIndex > -1) {
          Object.assign(this.startVarsItems[this.editedStartVarIndex], this.editedStartVarItem);
        } else {
          this.startVarsItems.push(this.editedStartVarItem);
        }
        this.closeEditStartVar();
      },
      closeEditStartVar() {
        this.editStartVarDialog = false;
        this.editedStartVarItem = {
          varName: '',
          varType: '',
          varValue: ''
        };
      },
      deleteStartVarItem(item) {
        this.editedStartVarIndex = this.startVarsItems.indexOf(item);
        this.editedStartVarItem = Object.assign({}, item);
        this.deleteStartVarDialog = true;
      },
      confirmDeleteStartVar() {
        this.startVarsItems.splice(this.editedStartVarIndex, 1);
        this.closeDeleteStartVar();
      },
      closeDeleteStartVar() {
        this.deleteStartVarDialog = false;
        this.$nextTick(() => {
          this.editedStartVarItem = Object.assign({}, this.defaultStartVarItem);
          this.editedStartVarIndex = -1;
        })
      },
      resetStartVars() {
        this.startVarsItems = [];
      },
      setStartVariables() {
        this.sourceProcesses = [];

        for(let i = 0; i < this.allProcesses.length; i++) {
          let sourceObj = {
            'label': this.allProcesses[i].name + ' - (Version: ' + this.allProcesses[i].version + ')',
            'value': this.allProcesses[i]
          }
          this.sourceProcesses.push(sourceObj);
        }

        this.setStartVarsDialog = true;
      },
      confirmSetStartVariables() {
        this.setStartVarsDialog = false;

        // Save to DB
        let payload = {
          'connId': 0,
          'processKey': this.sourceProcess.key,
          'starterVars': JSON.stringify(this.startVarsItems)
        }
        
        this.$store.dispatch('setStarterVars', payload);

        this.closeSetStartVariables();
      },
      closeSetStartVariables() {
        this.setStartVarsDialog = false;
        this.sourceProcess = {};
        this.sourceProcesses = [];
        this.resetStartVars();
      },
      buildProcess() {
        this.$store.commit('UPDATE_PROCESS_ID', '');
        this.$store.commit('UPDATE_DEPLOYMENT_NAME', '');
        this.$store.commit('UPDATE_PROCESS_VERSION', 1);
        this.$store.commit('UPDATE_PROCESS_ACTION', 'new');
        this.$store.commit('EDITING_PROCESS', true);
        this.$router.push({ name: 'BuildProcess' });
      },
      cancelImportProcess() {
        this.importProcessDialog = false;
        this.importedFile = null;
      },
      importProcess() {
        this.importTitle = this.$t('PROCESSES.IMPORT_PROCESS.TITLE');
        this.importText = this.$t('PROCESSES.IMPORT_PROCESS.DESC');
        this.importProcessDialog = true;
      },
      confirmImportProcess() {
        let fileData = this.importedFile.name.split('.');
        if(fileData[1] != 'bpmn' && fileData[1] != 'xml') {
          this.snackImportError();
        }else {
          this.importProcessDialog = false;
          let ref = this;
          this.readFile(this.importedFile, function(f) {
            let xml = f.target.result;
            ref.$store.commit('UPDATE_PROCESS_ID', '');
            ref.$store.commit('UPDATE_DEPLOYMENT_NAME', '');
            ref.$store.commit('UPDATE_PROCESS_VERSION', 1);
            ref.$store.commit('UPDATE_IMPORT_XML', xml);
            ref.$store.commit('UPDATE_PROCESS_ACTION', 'import');
            ref.$router.push({ name: 'BuildProcess' });
          });
        }
      },
      editProcess(item) {
        let payload = {
          'processId': item.ID,
          'processKey': item.PROCESS_KEY,
          'checkType': 'single'
        };
        this.$store.dispatch('processLockCheck', payload).then(() => {
          if(this.processLocked) {
            this.showLocked(this.processLockedUser);
            this.refreshProcesses();
          }else {
            this.$store.commit('UPDATE_PROCESS_ID', item.ID);
            this.$store.commit('UPDATE_DEPLOYMENT_NAME', item.NAME);
            this.$store.commit('UPDATE_PROCESS_KEY', item.PROCESS_KEY);
            this.$store.commit('UPDATE_PROCESS_VERSION', item.VERSION);
            this.$store.commit('UPDATE_PROCESS_ACTION', 'edit');
            this.$store.commit('EDITING_PROCESS', true);
            this.$router.push({ name: 'BuildProcess' });
          }
        });
      },
      viewProcessMap(item) {
        this.theProcessName = item.name;
        this.$store.dispatch('getProcessMap', item.id);
      },
      closeProcessMap() {
        let canvas = document.getElementById('canvas');
        canvas.innerHTML = '';
        this.processMapDialog = false;
      },
      deleteProcess(item) {
        let payload = {
          'processId': 0,
          'processKey': item.key,
          'checkType': 'single'
        };
        this.$store.dispatch('processLockCheck', payload).then(() => {
          if(this.processLocked) {
            this.showLocked(this.processLockedUser);
            this.refreshProcesses();
          }else {
            this.deleteTitle = this.$t('PROCESSES.UNDEPLOY_PROCESS.TITLE');
            this.deleteTextProcess = this.$t('PROCESSES.UNDEPLOY_PROCESS.DESC_1') + ' ' + item.name;
            this.deleteTextVersion = this.$t('PROCESSES.UNDEPLOY_PROCESS.DESC_2') + ' ' + item.version;
            this.deleteTextWarning = this.$t('PROCESSES.UNDEPLOY_PROCESS.DESC_3');
            this.deploymentId = item.deploymentId;
            this.deleteKey = item.key;
            this.theProcessName = item.name;
            this.theProcessDefinitionId = item.id;
            this.deleteDialog = true;
          }
        });
      },
      confirmDelete() {
        this.loadingUndeploy = true;
        let payload = {
          'id': this.deploymentId,
          'processId': this.theProcessDefinitionId
        };
        this.$store.dispatch('deleteDeployment', payload).then( () => {
          this.loadingUndeploy = false;
          this.deleteDialog = false;
          this.updateLog('Process', 'Undeployed', this.theProcessName, 'Process ' + this.theProcessName + ' was undeployed.');

          this.refreshProcesses();
          this.snackDelete();
        });
      },
      deleteProcessXml(item) {
        this.deleteTitle = this.$t('PROCESSES.DELETE_PROCESS.TITLE');
        this.deleteTextProcess = this.$t('PROCESSES.DELETE_PROCESS.DESC') + ' ' + item.NAME;
        this.xmlId = item.ID;
        this.theProcessName = item.PROCESS_NAME;
        this.deleteXmlDialog = true;
      },
      confirmDeleteXml() {
        this.deleteXmlDialog = false;

        this.$store.dispatch('deleteProcessXml', this.xmlId).then( () => {
          this.updateLog('Process', 'Deleted', this.theProcessName, 'Process ' + this.theProcessName + ' deleted.');

          this.refreshProcesses();
          this.snackDeleteXml();
        });
      },
      forceUnlock() {
        this.$store.commit('EDITING_PROCESS', false);
        let payload = {
          'checkType': 'unlock',
          'processId': 0,
          'processKey': this.lockedProcessKey,
        };
        this.$store.dispatch('processLockCheck', payload).then( () => {
          this.showLockedDialog = false;
          this.refreshProcesses();
        });
      },
      showLocked(item) {
        let user = item.LOCKED_BY;
        this.lockedProcessKey = item.PROCESS_KEY;
        this.lockedTitle = this.$t('PROCESSES.PROCESS_LOCKED.TITLE');
        this.lockedText = this.$t('PROCESSES.PROCESS_LOCKED.DESC') + ' ' + user + '.';
        this.showLockedDialog = true;
      },
      snackMigration(success) {
        if(success) {
          this.snackColor = 'success'
          this.snackText = 'Processes migrated successfully.'
        }else {
          this.snackColor = 'error'
          this.snackText = 'Process migration failed.'
        }
        this.snack = true
      },
      snackSetVar(success) {
        if(success) {
          this.snackColor = 'success'
          this.snackText = 'Variable set successfully.'
        }else {
          this.snackColor = 'error'
          this.snackText = 'Failed to set variable.'
        }
        this.snack = true
      },
      snackVarsSaved(success) {
        if(success) {
          this.snackColor = 'success'
          this.snackText = 'Starter variables saved successfully.'
        }else {
          this.snackColor = 'error'
          this.snackText = 'Failed to save starter variables.'
        }
        this.snack = true
      },
      snackDelete () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Process version deleted successfully.'
      },
      snackDeleteXml () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Process design deleted successfully.'
      },
      snackImportError () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Incorrect file type. Please upload either a BPMN or XML file.'
      },
      updateLog(cat, op, process, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': 0,
          'processName': process,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>

<style>
  .warning-text {
    color: red;
  }
</style>